import { ValidationErrors } from "@/components/Register/registrationForm.component";
import { Button } from "@/shadcn/components/ui/button";
import { Checkbox } from "@/shadcn/components/ui/checkbox";
import { Label } from "@/shadcn/components/ui/label";
import React from "react";

type UserConsentProps = {
  consent: {
    marketing: boolean;
    terms: boolean;
    privacy: boolean;
  };
  setConsent: React.Dispatch<
    React.SetStateAction<{
      marketing: boolean;
      terms: boolean;
      privacy: boolean;
    }>
  >;
  errors: ValidationErrors;
};

const UserConsent: React.FC<UserConsentProps> = ({
  consent,
  setConsent,
  errors,
}) => {
  return (
    <div className="">
      <div className="flex flex-col gap-2">
        <Label className="flex items-center gap-2">
          <Checkbox
            checked={consent.terms}
            onCheckedChange={(checked) =>
              setConsent({ ...consent, terms: Boolean(checked) })
            }
          />
          <span className="select-none">
            Agree to{" "}
            <Button
              type="button"
              variant="link"
              className="h-auto p-0"
              onClick={() =>
                window.open(
                  "https://www.vulcansteel.co.za/files/terms/Vulcan_Steel_Manufacturing-Terms-Conditions.pdf",
                  "_blank"
                )
              }
            >
              Terms & Conditions
            </Button>
          </span>
          <span className="text-red-500">*</span>
          {errors.consentTerms && (
            <p className="text-sm text-red-500">{errors.consentTerms}</p>
          )}
        </Label>

        <Label className="flex items-center gap-2">
          <Checkbox
            checked={consent.privacy}
            onCheckedChange={(checked) =>
              setConsent({ ...consent, privacy: Boolean(checked) })
            }
          />
          <span className="select-none">
            Agree to{" "}
            <Button variant="link" className="h-auto p-0" type="button">
              Privacy Policy
            </Button>
          </span>
          <span className="text-red-500">*</span>
          {errors.consentPrivacy && (
            <p className="text-sm text-red-500">{errors.consentPrivacy}</p>
          )}
        </Label>
        <Label className="flex items-center gap-2">
          <Checkbox
            checked={consent.marketing}
            onCheckedChange={(checked) =>
              setConsent({ ...consent, marketing: Boolean(checked) })
            }
          />
          <span className="select-none">
            Agree to receive marketing communications{" "}
          </span>
        </Label>
      </div>
    </div>
  );
};

export default UserConsent;
